import { ResponsivePictureLayout } from '@news-mono/component-library'
import { layout } from '../../App.routing'

interface cardLayoutProps {
    featureToggle:
        | 'the-west-grand-final-collection'
        | 'queens-legacy-listing'
        | 'queens-legacy-home'
    curation: 'afl-grand-final' | 'queens-legacy'
    themeOverride: 'grand-final' | 'queens-legacy'
}

const fourCardLayout = ({
    featureToggle,
    curation,
    themeOverride,
}: cardLayoutProps) => {
    return layout.nestedComposition({
        type: 'thor',
        feature: featureToggle,
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            themeOverride: themeOverride,
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'lima',
                    props: {
                        section: 'default',
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                        },
                        cardLayout: [
                            ['teaserWithBackground'],
                            ['teaserWithBackground'],
                            ['teaserWithBackground'],
                            ['teaserWithBackground'],
                        ],
                        intermediateColumns: 2,
                        finalColumns: 4,
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: curation,
                            pageSize: 4,
                            offset: 0,
                        },
                        hasBorder: false,
                    },
                }),
            ],
        },
    })
}

const nineCardLayout = ({
    featureToggle,
    curation,
    themeOverride,
}: cardLayoutProps) => {
    return layout.nestedComposition({
        type: 'thor',
        feature: featureToggle,
        props: {
            hasBackgroundFill: true,
            containerWidth: '100%',
            verticalGutters: false,
            horizontalGutters: true,
            themeOverride: themeOverride,
            verticalSpacing: 'lg',
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'sierra',
                    props: {
                        verticalSpacing: 'gridGap',
                        fixedRatios: ['16:9'],
                        heroImageLayout:
                            ResponsivePictureLayout.ObjectFitContain,
                        cardOrientation: {
                            type: 'Landscape-Portrait',
                            maxBreakpoint: 'md',
                        },
                        cardLayout: ['hero', 'teaser-xsVisible-mdHidden-Image'],

                        dataDefinitionArgs: {
                            type: 'curation',
                            name: curation,
                            offset: 0,
                            pageSize: 2,
                        },
                    },
                }),
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: false,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: false,
                    },
                    contentAreas: {
                        main: [
                            layout.nestedComposition({
                                type: 'janus',
                                props: {
                                    layoutRatio: '3:1',
                                    stretchColumns: true,
                                    verticalSpacing: 'sm',
                                    hasBorder: false,
                                    usePodcastToggleValue: true,
                                },
                                contentAreas: {
                                    left: [
                                        layout.component({
                                            type: 'lima',
                                            props: {
                                                section: 'default',
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                },
                                                cardLayout: [
                                                    ['teaserWithBackground'],
                                                    [
                                                        'xsImage-mdNoImage-withBG',
                                                        'xsImage-mdNoImage-withBG',
                                                    ],
                                                    [
                                                        'xsImage-mdNoImage-withBG',
                                                        'xsImage-mdNoImage-withBG',
                                                    ],
                                                ],
                                                intermediateColumns: 3,
                                                finalColumns: 3,
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: curation,
                                                    pageSize: 5,
                                                    offset: 2,
                                                },
                                                hasBackground: false,
                                                hasBorder: false,
                                            },
                                        }),
                                    ],
                                    right: [
                                        layout.component({
                                            type: 'lima',
                                            props: {
                                                section: 'default',
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                },
                                                cardLayout: [
                                                    ['teaserWithBackground'],
                                                ],
                                                intermediateColumns: 1,
                                                finalColumns: 1,
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: curation,
                                                    pageSize: 1,
                                                    offset: 7,
                                                },
                                                hasBackground: false,
                                                hasBorder: false,
                                            },
                                        }),
                                    ],
                                },
                            }),
                        ],
                    },
                }),
            ],
        },
    })
}

export function getThemedSegment(props: {
    featureToggle:
        | 'the-west-grand-final-collection'
        | 'queens-legacy-listing'
        | 'queens-legacy-home'
    layoutVersion: '4-card' | '9-card'
    curation: 'afl-grand-final' | 'queens-legacy'
    themeOverride: 'grand-final' | 'queens-legacy'
}) {
    if (props.layoutVersion === '4-card') {
        return fourCardLayout({
            featureToggle: props.featureToggle,
            curation: props.curation,
            themeOverride: props.themeOverride,
        })
    }
    return nineCardLayout({
        featureToggle: props.featureToggle,
        curation: props.curation,
        themeOverride: props.themeOverride,
    })
}
